import React from 'react'
import updateCurrentProductIdAction from 'modules/product/redux/actions/update-current'
import addProductAndVariantIdToUrlProductUtil from 'modules/product/utils/add-product-and-variant-id-to-url'
import updateCurrentVariantIdAction from 'modules/variant/redux/actions/update-current'
import updateIsSampleVariantIdAction from 'modules/variant/redux/actions/update-is-sample'
import updateSelectedColorVariantIdVariantAction from 'modules/variant/redux/actions/update-selected-color-variant-id'
import runAfterDelayTimingUtil from 'utils/timing/run-after-delay'
import updateShouldUpdateMediaAction from 'modules/media-gallery/redux/actions/update-should-update-media'
import getPriceLabelStringUtil from 'utils/string/get-price-label'
import View from 'components/View'
import Image from 'components/Image'
import Span from 'components/Span'
import getSizeGuideLabelElementProductUtil from 'modules/product/utils/get-size-guide-label-element'
import BulletIcon from 'components/Icons/Bullet'
import TextSemiBold from 'components/TextSemiBold'
import classNames from 'classnames'
import logUtil from 'utils/log'
import useDispatch from 'hooks/use-dispatch'
import getDiscountedPriceVariantSelector from 'modules/variant/redux/selectors/get-discounted-price'
import useSelector from 'hooks/use-selector'
import isProductUrlLocationUtil from 'utils/location/is-product-url'
import getCurrentIdVariantSelect from 'modules/variant/redux/selectors/get-current-id'

/**
 * @param {VariantButtonProps} props
 * @return {JSX.Element}
 * @constructor
 */
export default function VariantButton ({
  LogoUrl,
  title,
  productId,
  variantId,
  isSample,
  subTitle,
  price,
  hasSecondaryFullSizeVariant,
  isSecondaryFullSizeVariant,
  isFullSizeActive,
  fullSizeVariantId,
  fullSizeProductId,
  productVariant
}) {
  const currentVariantId = useSelector(getCurrentIdVariantSelect)
  const isActive = currentVariantId === variantId
  const discountPrice = useSelector(
    getDiscountedPriceVariantSelector({
      variantId,
      productVariant,
      shouldLog: true
    })
  )
  const debugProps = {
    LogoUrl,
    title,
    productId,
    variantId,
    isSample,
    subTitle,
    price,
    hasSecondaryFullSizeVariant,
    isSecondaryFullSizeVariant,
    isFullSizeActive,
    fullSizeVariantId,
    currentVariantId,
    fullSizeProductId,
    productVariant,
    discountPrice
  }

  logUtil('VariantButton').debug('[start] debugProps=', debugProps)

  const dispatch = useDispatch()
  const updateCurrentProduct = async () => {
    dispatch(updateCurrentProductIdAction(productId))
    dispatch(updateCurrentVariantIdAction(variantId))
    dispatch(updateIsSampleVariantIdAction(isSample))

    addProductAndVariantIdToUrlProductUtil({
      productId,
      variantId
    })

    dispatch(updateShouldUpdateMediaAction(false))

    dispatch(
      updateSelectedColorVariantIdVariantAction({
        variantId,
        shouldUpdateMediaGallery: true,
        fromSidebar: true
      })
    )

    /**
     * 3 seconds delay so no other, function can force update media gallery
     */
    await runAfterDelayTimingUtil(3000)
    dispatch(updateShouldUpdateMediaAction(true))
  }

  const handleClick = () => {
    updateCurrentProduct()
  }

  const result = getSizeGuideLabelElementProductUtil({
    sizeLabel: subTitle
  }) || {}
  const {
    element,
    secondLine
  } = result

  // TODO: for PDP using price as its breaking for discount price need to debug this with @James
  const isPdp = isProductUrlLocationUtil()
  const priceToUse = discountPrice ?? price
  if (isPdp) {
    // priceToUse = price
  }

  let subTitleElement
  if (priceToUse === '0.00') {
    subTitleElement = element
  } else {
    subTitleElement = (
      <Span>
        <TextSemiBold>
          {getPriceLabelStringUtil(Number(priceToUse))}
        </TextSemiBold> {!!element && <BulletIcon />} {element}
      </Span>
    )
  }

  return (
    <View
      onClick={handleClick}
      className={
        classNames({
          'variant-button-container': true,
          'variant-button_large': !!secondLine,
          active: isActive
        })
      }
    >
      <Image
        className='variant-button-logo'
        src={LogoUrl}
      />
      <View>
        <View className='airshop-option-text toggle-button-title'>
          {title}
        </View>

        <View className='toggle-button-subtitle'>
          {subTitleElement}
        </View>
      </View>

    </View>
  )
}
